import { Trans } from "@lingui/react/macro";
import { Box, Button, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import { IconLogout, IconRefresh, IconServerOff } from "@tabler/icons-react";
import { repair } from "@/utils/auth/repair";

export default function ErrorServer() {
	return (
		<Stack h="100vh" justify="center" align="center" p="md">
			<ThemeIcon variant="transparent" size={64} color="red">
				<IconServerOff style={{ width: "100%", height: "100%" }} />
			</ThemeIcon>

			<Title ta="center" order={1}>
				<Trans>No se puede conectar con el servidor</Trans>
			</Title>

			<Text ta="center" size="lg">
				<Trans>Verifica tu conexión a internet e inténtalo de nuevo.</Trans>
			</Text>

			<Box>
				<Stack align="center">
					<Button
						size="lg"
						leftSection={<IconRefresh />}
						onClick={() => window.location.reload()}
					>
						<Trans>Reintentar</Trans>
					</Button>

					<Button
						variant="subtle"
						color="red"
						leftSection={<IconLogout />}
						onClick={() => repair()}
					>
						<Trans>Cerrar sesión</Trans>
					</Button>
				</Stack>
			</Box>
		</Stack>
	);
}
